import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BailListComponent } from './bail-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BailService } from './bail.service';

@Component({
    selector: 'convfact-baildelete',
    templateUrl: './bail-dialog-delete.component.html',
    styleUrls: ['./bail.component.css'],
    standalone: false
})
export class BailDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<BailListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public bailService: BailService
    ) { }

    delete() {
        this.bailService.deleteData(this.uid);
        this.dialogRef.close();
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}